import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

const TextInput = ({ label, asterisk, onChange, value, ...rest }) => {
	return (
		<Box display="block">
			<Typography variant="overline" display="block">
				{label}
				{asterisk ? (
					<Typography
						variant="overline"
						sx={{ color: "red", fontWeight: "bold" }}
					>
						*
					</Typography>
				) : null}
			</Typography>
			<TextField value={value} onChange={onChange} {...rest} />
		</Box>
	);
};

export default TextInput;
